// 3_pages/product_edit_detail_params_urls.js
// On product pages, rewrites the detail-parameter links so they point at the
// product's parent category (from the breadcrumb) while keeping each link's query
// string.

export function init() {
	if (!document.body.classList.contains("type-product")) return;

	updateDetailParametersUrls();
}

function updateDetailParametersUrls() {
	const detailParameters = document.querySelector(".extended-description .detail-parameters");
	if (!detailParameters) {
		return;
	}

	const breadcrumbLinks = Array.from(
		document.querySelectorAll(".breadcrumbs.navigation-home-icon-wrapper a[href]"),
	).filter((a) => !a.closest("#navigation-first"));

	if (breadcrumbLinks.length < 2) {
		return;
	}
	const baseUrl = breadcrumbLinks[breadcrumbLinks.length - 2].getAttribute("href");

	const links = detailParameters.querySelectorAll("a");
	links.forEach((link, index) => {
		if (index === 0) return;
		const href = link.getAttribute("href");
		const queryStart = href.indexOf("?");
		if (queryStart !== -1) {
			link.setAttribute("href", baseUrl + href.slice(queryStart));
		} else {
			link.setAttribute("href", baseUrl);
		}
	});
}
